// extracted by mini-css-extract-plugin
export default {"list":"Home_list__69yRm","card":"Home_card__kcYKa","image":"Home_image__zkiyJ"};